import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';
import { ChunkLoadErrorBoundary } from '@trello/error-reporting';
import type { ViewSwitcherProps } from './ViewSwitcher';
import { Spinner } from '@trello/nachos/spinner';
export const LazyViewSwitcher: FunctionComponent<ViewSwitcherProps> = (
  props,
) => {
  const ViewSwitcher = useLazyComponent(
    () => import(/* webpackChunkName: "view-switcher" */ './ViewSwitcher'),
    { namedImport: 'ViewSwitcher' },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={<Spinner />}>
        <ViewSwitcher {...props} />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
